<template>
  <v-dialog
      class="hide-on-print"
      v-model="value"
      persistent
      width="800">

    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Edit {{data.status}} Track</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <FormErrorDisplayHandler :errors="errors"/>
            <v-flex xs12>
              <v-form class="pa-2" lazy-validation ref="manualRef">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                        label="Remarks *"
                        :rules="[rules.required]"
                        outlined
                        v-model="adData.remarks"
                    />
                  </v-flex>
                  <v-autocomplete
                      :clearable="true"
                      :items="all"
                      :rules="[rules.required]"
                      item-text="country_name"
                      item-value="id"
                      :label="data.statusNumber === 11 ? 'Country Arrived From *' : 'Country Departed To *'"
                      outlined
                      v-model="adData.country"
                  ></v-autocomplete>
                  <v-flex xs12>
                    <v-autocomplete
                        :clearable="true"
                        :items="flight_numbers"
                        :rules="[rules.required]"
                        item-text="flight_number"
                        item-value="flight_number"
                        label="Flight Number *"
                        outlined
                        v-model="adData.flight_bus_number"
                        @change="getAirlineAirportDetails"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        label="Airport"
                        outlined
                        readonly
                        v-model="adData.airport_name"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        label="Travelled Airline"
                        outlined
                        readonly
                        v-model="adData.airline_name"
                    />
                  </v-flex>
                  <v-flex xs12 v-if="data.statusNumber == 11">
                  <v-autocomplete
                      :rules="[rules.required]"
                      outlined
                      label="Purpose of arrival *"
                      :items="purpose_of_arrivals"
                      v-model="adData.purpose_of_visit"
                  ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 v-if="data.statusNumber == 12">
                    <v-autocomplete
                        :rules="[rules.required]"
                        outlined
                        label="Purpose of departure *"
                        :items="purpose_of_departures"
                        v-model="adData.purpose_of_visit"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        label="Reason to modify *"
                        :rules="[rules.required]"
                        outlined
                        v-model="adData.reason_to_modify"
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider style="margin-top:10px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            @click="cancel"
            class="white--text"
            color="red darken-3"
        >Cancel
        </v-btn>
        <v-btn
            @click="save"
            :loading="loading"
            class="white--text"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import FileInput from "../FileInput";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import {mapActions, mapGetters} from "vuex";
import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";

export default {
  name: "ArrivalDepartureTrackEditDialog",
  components: {FormErrorDisplayHandler, FileInput},
  props: ['value','data'],
  mixins: [validationMixin],
  data() {
    return {
      files: [],
      innerOpen: false,
      loading: false,
      flight_numbers:null,
      errors:null,
      purpose_of_arrivals:[],
      purpose_of_departures:[],
      reason_to_modify:null
    }
  },
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    },
  },
  computed:{
    ...mapGetters("CountryList",['all']),
    adData(){
      let data = {};
      data.remarks = this.data.extra.remarks ? this.data.extra.remarks : null
      data.country = this.data.extra.country ? this.data.extra.country.id : null
      data.flight_bus_number = this.data.extra.flight_bus_number ? this.data.extra.flight_bus_number : null
      data.id = this.data.id;
      data.reason_to_modify = this.reason_to_modify;
      data.purpose_of_visit = this.data.extra.purpose_of_visit ? this.data.extra.purpose_of_visit : null
      return data;
    }
  },
  methods: {
    ...mapActions('CountryList',['fetchAllCountries']),
    getAirlineAirportDetails(){
      let data = this.flight_numbers.find(item=>{
       return  item.flight_number == this.data.extra.flight_bus_number
      });
      this.adData.airport_name = data.statusNumber == 11 ? data.source_airport.airport_name : data.destination_airport.airport_name
      this.adData.airline_name = data.airline.airline_name
    },
    getAllFlightNumbers(){
      Http.get(VERSIONED_API_URL + '/flight-numbers-all').then(r=>{
        this.flight_numbers = r.data.data;
      })
    },
    async save() {
      if (this.$refs.manualRef.validate()) {
        try {
          this.loading = true;
          // const formData = new FormData();
          // formData.set('remarks',this.data.extra.remarks);
          // formData.set('country',this.data.extra.country.id);
          // formData.set('flight_bus_number',this.data.extra.flight_bus_number);
          // formData.set('id',this.data.id);
          // formData.set('reason_to_modify',this.reason_to_modify);
          // formData.set('purpose_of_visit',this.data.extra.purpose_of_visit);
          const response = await Http.post(VERSIONED_API_URL + '/visa-visit-track/modify-arrival-departure-track', this.adData);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.loading = false;
          this.$emit('input', false);
          this.innerOpen = false;
          this.$emit('edited')
        } catch (e) {
          this.$store.commit('Notification/showError', e.response.data.message);
          this.loading = false;
        }

      }
      else{
        this.$store.commit('Notification/showError', 'File is required');
      }
    },
    cancel() {
      this.innerOpen = false;
      this.$emit('edited')
      this.$emit('input', false)
    }
  },
  mounted() {
    this.getAllFlightNumbers()
    fetchDynamicValues('purposeOfArrival').then((res) => {
      this.purpose_of_arrivals = res;
    })
    fetchDynamicValues('purposeOfDeparture').then((res) => {
      this.purpose_of_departures = res;
    })
  }
}
</script>

